import { z } from 'zod';
import { requiredString } from '../helpers';
export const Strada_Validate_Intake_1_ConfigValidator = z.object({
    callId: requiredString('Call ID path is required'),
    validationScope: z.enum(['complete', 'current-progress'])
});
//# sourceMappingURL=strada-validate-intake-1.js.map